import React, { useState } from 'react';
import Title from '@/components/title';
import { ISearchMediaReq, ISearchMediaRes } from '@/interfaces/media';
import { AxiosResponse } from 'axios';
import { useQuery } from '@tanstack/react-query';
import { searchMedias } from '@/adapters/media';
import MediaUploader from '@/components/media/uploader-modal';
import { PlusOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import MediaCard from '@/components/card/media-card';
import { IOrder } from '@/interfaces/order';
import { isWareHouse } from '@/utils/permissionUtils';

interface IProps {
  data: IOrder;
}

const _criteria: ISearchMediaReq = {
  orderBy: 'id',
  orderType: 'descend',
  pageSize: -1,
  pageStart: 1,
  search: '',
  modelType: 'order',
};

const OrderFiles = ({ data }: IProps) => {
  const perIsWareHouse = isWareHouse();
  const [criteria] = useState<ISearchMediaReq>({
    ..._criteria,
    modelId: data.id,
  });
  const [isUpload, setIsUpload] = useState(false);

  const { data: medias, refetch } = useQuery<
    AxiosResponse<ISearchMediaRes>,
    Error
  >({
    queryKey: ['search-media', criteria],
    queryFn: async () => await searchMedias(criteria),
  });

  const documents = medias?.data?.data || [];

  return (
    <>
      <Title customClassName="text-lg text-blue-700" title={`เอกสารต่างๆ`}>
        <Button ghost type="primary" onClick={() => setIsUpload(true)}>
          <PlusOutlined />
          อัพโหลดไฟล์
        </Button>
      </Title>
      <div className="flex flex-col gap-2">
        {documents.map(d => {
          return (
            <MediaCard
              key={d.id}
              media={d}
              onDeleted={() => refetch()}
              isDownload
              readonly={perIsWareHouse}
            />
          );
        })}
      </div>

      <MediaUploader
        data={{
          modelId: data?.id,
          modelType: criteria.modelType || 'order',
        }}
        open={isUpload}
        onCancel={() => setIsUpload(false)}
        onUploaded={() => {
          setIsUpload(false);
          refetch();
        }}
      />
    </>
  );
};

export default OrderFiles;
